import {
  DeleteDonorRequest,
  DonatoreResponse,
  NewDonationRequest,
  NewDonorRequest, NewNotaRequest,
  RaccoltaCalendarEvent,
  RaccoltaResponse,
  TemplateResponse
} from "../../types";
import {BE_BASE_URL} from "../../utils/config";

export const fetchTemplates = async (): Promise<TemplateResponse[]> => {
  const response = await fetch(BE_BASE_URL + '/raccolta/getAllTemplates', {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('token')}`,
    },
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return await response.json();
};

export const createNewRaccolta = async (request: NewDonationRequest): Promise<void> => {
  const response = await fetch(BE_BASE_URL + '/raccolta/create', {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('token')}`,
    },
    body: JSON.stringify(request),
  });

  if (!response.ok) {
    const errorBody = await response.text();
    console.error(`HTTP error! status: ${response.status}, body: ${errorBody}`);
    throw new Error(`HTTP error! status: ${response.status}`);
  }
};

export const fetchAllRaccolte = async (): Promise<RaccoltaCalendarEvent[]> => {
  const token = localStorage.getItem('token');
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  const response = await fetch(BE_BASE_URL + '/raccolta/getAllEvents', {
    method: "GET",
    headers: headers,
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return await response.json();
};

export const fetchRaccoltaById = async (id: number): Promise<RaccoltaResponse> => {
  const token = localStorage.getItem('token');
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  const response = await fetch(`${BE_BASE_URL}/raccolta/getRaccolta?id=${id}` , {
    method: "GET",
    headers: headers,
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return await response.json();
};

export const deleteRaccoltaById = async (id: number): Promise<void> => {
  const response = await fetch(`${BE_BASE_URL}/raccolta/deleteRaccolta?id=${id}` , {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('token')}`,
    },
  });

  if (!response.ok) {
    const errorBody = await response.text();
    console.error(`HTTP error! status: ${response.status}, body: ${errorBody}`);
    throw new Error(`HTTP error! status: ${response.status}`);
  }
};

export const addNotaToRaccolta = async (request: NewNotaRequest): Promise<void> => {
  const response = await fetch(`${BE_BASE_URL}/raccolta/addNotaToRaccolta` , {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('token')}`,
    },
    body: JSON.stringify(request),
  });

  if (!response.ok) {
    const errorBody = await response.text();
    console.error(`HTTP error! status: ${response.status}, body: ${errorBody}`);
    throw new Error(`HTTP error! status: ${response.status}`);
  }
};

export const addNewDonor = async (request: Partial<NewDonorRequest>): Promise<void> => {
  const token = localStorage.getItem('token');
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  const response = await fetch(BE_BASE_URL + '/raccolta/addDonor', {
    method: "POST",
    headers: headers,
    body: JSON.stringify(request),
  });

  if (!response.ok) {
    const errorBody = await response.text();
    console.error(`HTTP error! status: ${response.status}, body: ${errorBody}`);
    throw new Error(errorBody);
  }
};

export const removeDonorFromRaccolta = async (request: DeleteDonorRequest): Promise<void> => {
  const response = await fetch(BE_BASE_URL + '/raccolta/deleteDonorFromRaccolta', {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('token')}`,
    },
    body: JSON.stringify(request),
  });

  if (!response.ok) {
    const errorBody = await response.text();
    console.error(`HTTP error! status: ${response.status}, body: ${errorBody}`);
    throw new Error(`HTTP error! status: ${response.status}`);
  }
};

export const fetchAllDonatoriRaccoltaById = async (id: number): Promise<DonatoreResponse[]> => {
  const response = await fetch(`${BE_BASE_URL}/raccolta/getAllDonorsByRaccoltaId?id=${id}` , {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('token')}`,
    },
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return await response.json();
};


